/**
 * Text the APP wrote (a role's or permission's label and description),
 * marked as the app's. React escapes it; it is never treated as markup.
 */
export function AppText({ children, appName }: { children: string; appName: string }) {
  return (
    <span title={`Text from ${appName}`} className="break-words">
      {children}
    </span>
  );
}
